<!-- [labelPosition]="isDarkMode ? 'after' : 'before'" -->
<!-- <mat-slide-toggle
  [checked]="isDarkMode"
  (change)="toggleTheme($event)"
  [labelPosition]="'before'"
>
  <mat-icon class="mr-1 mt-2" *ngIf="!isDarkMode">wb_sunny</mat-icon>
  <mat-icon class="ml-1 mt-2" *ngIf="isDarkMode">nights_stay</mat-icon>
</mat-slide-toggle> -->

<mat-button-toggle
  class="custom-toggle flex items-center justify-center !bg-transparent !shadow-none border-none"
  (click)="toggleTheme()"
  disableRipple
>
  <mat-icon>{{ config?.scheme === 'light' ? 'nights_stay' : 'wb_sunny' }}</mat-icon>
</mat-button-toggle>



